import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Building2, Mic, ShieldCheck, Users } from "lucide-react";
import { Brand } from "@/components/common";
import { INTENT_KEY } from "@/pages/Onboarding";

function RegisterChoice({ onPick }) {
  return (
    <div className="register-choice" data-testid="register-choice">
      <p className="eyebrow">REGISTER AS NEW</p>
      <h2>Who are you registering as?</h2>
      <button className="choice" onClick={() => onPick("clinic")} data-testid="register-as-clinic"><Building2 size={18} /><b>A new clinic (administrator)</b><small>Create your clinic workspace and invite your team</small></button>
      <button className="choice" onClick={() => onPick("join")} data-testid="register-as-team"><Users size={18} /><b>Team member of a clinic</b><small>Dentist, receptionist, accountant or admin. Your clinic admin approves you.</small></button>
    </div>
  );
}

export default function AuthPage({ mode }) {
  const { pathname } = useLocation();
  const [intent, setIntent] = useState(localStorage.getItem(INTENT_KEY));
  const pick = (v) => { localStorage.setItem(INTENT_KEY, v); setIntent(v); };
  const midFlow = pathname.replace(/\/$/, "") !== "/sign-up";
  return (
    <main className="login-shell">
      <section className="login-visual">
        <Brand />
        <div className="login-copy">
          <p className="eyebrow">CLINIC OPERATIONS, REIMAGINED</p>
          <h1>Speak your day.<br /><em>Keep your focus.</em></h1>
          <p>One calm workspace for the clinical notes, patient ledgers and decisions that keep your clinic moving.</p>
          <div className="voice-orbit"><div className="orbit-ring"><Mic size={34} /></div><span>EN · HI · HINGLISH</span></div>
        </div>
        <div className="login-footer">Each clinic's data is private to that clinic <ShieldCheck size={14} /></div>
      </section>
      <section className="login-panel" data-testid={mode === "up" ? "sign-up-panel" : "sign-in-panel"}>
        <div className="auth-mobile-brand"><Brand /></div>
        <div className="auth-tabs">
          <Link to="/sign-in" className={mode === "in" ? "auth-tab active" : "auth-tab"} data-testid="auth-tab-sign-in">Sign in</Link>
          <Link to="/sign-up" className={mode === "up" ? "auth-tab active" : "auth-tab"} data-testid="auth-tab-register">Register as new</Link>
        </div>
        {mode === "in" && <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />}
        {mode === "up" && !intent && !midFlow && <RegisterChoice onPick={pick} />}
        {mode === "up" && (intent || midFlow) && <>
          {intent && <p className="intent-note" data-testid="register-intent-note">Registering as {intent === "clinic" ? "a new clinic (administrator)" : `a clinic team member${localStorage.getItem("df_join_code") ? ` (invite code ${localStorage.getItem("df_join_code")})` : ""}`} · <button className="link-btn" onClick={() => { localStorage.removeItem(INTENT_KEY); setIntent(null); }} data-testid="change-register-intent">change</button></p>}
          <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
        </>}
      </section>
    </main>
  );
}
